import React from "react";
import { Navigate } from "react-router-dom";
import { Lock } from "lucide-react";

const PREVIEW_IMAGES = {
  dashboard:              "/subscription-previews/dashboard.png",
  pricing_co_pilot:       "/subscription-previews/pricing_co_pilot.png",

  bi_inventory:           "/subscription-previews/bi_inventory.png",
  bi_sales:               "/subscription-previews/bi_sales.png",
  stock_performance:      "/subscription-previews/stock_performance.png",
  market_performance:     "/subscription-previews/market_performance.png",
};

const SubscriptionGate = ({ featureKey, subscriptionDetails, userAccess, isCsr, children }) => {
  if (!isCsr && userAccess && userAccess[featureKey] === false) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isCsr || !subscriptionDetails || subscriptionDetails[featureKey] !== false) {
    return children;
  }

  const previewSrc = PREVIEW_IMAGES[featureKey];

  return (
    <div className="relative h-full w-full overflow-hidden">
      {/* Screenshot blurred behind — real component never mounts */}
      <div className="absolute inset-0 pointer-events-none select-none scale-105 origin-top" aria-hidden="true">
        {previewSrc ? (
          <img src={previewSrc} alt="" className="w-full h-full object-cover object-top blur-sm" />
        ) : (
          <div className="w-full h-full bg-[#f6f9ff]" />
        )}
      </div>

      <div className="absolute inset-0 bg-white/20" />

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 bg-white rounded-2xl shadow-xl p-10 max-w-sm w-full text-center border border-gray-100">
          <div className="flex items-center justify-center w-14 h-14 rounded-full bg-[#e8ebff]">
            <Lock className="h-7 w-7 text-[#4154f1]" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-1">Feature Not Available</h3>
            <p className="text-sm text-gray-500">
              This feature is not included in your current subscription plan.
            </p>
          </div>
          <a
            href="mailto:support@liquid.diamonds"
            className="mt-2 inline-block px-6 py-2 rounded-lg bg-[#4154f1] text-white text-sm font-medium hover:bg-[#3040d0] transition-colors no-underline"
          >
            Contact us to upgrade
          </a>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionGate;
